import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import api from './api/api'
import './plugins/element.js'
import './plugins/tagcanvas.min.js'
import '../theme/index.css'
import './assets/iconfont/iconfont.css'
import './assets/hz.less'
import './assets/index.less'
import ElementUi from 'element-ui'
import moment from 'moment'
import 'videojs-contrib-hls'
import uploader from 'vue-simple-uploader'
Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$moment = moment
Vue.use(router)
Vue.use(ElementUi)
Vue.use(VueAxios, axios);
Vue.use(uploader)
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
if (!localStorage.getItem('user')) {
  if (router.history.current.name == 'admin') {
    router.push({ path: '/admin' })
  } else {
    router.push({ path: '/login' })
    // router.push({ path: '/bj' })
  }

} else {
  if (router.history._startLocation==='/') {
    if (localStorage.getItem('role') == 'M') {
      router.push({ path: '/zygl' })
    } else {
      router.push({ path: '/kbxmList' })
    }
  }else{
    router.push({ path: router.history._startLocation })
  }
}
router.beforeEach((to, from, next) => {
  //根据字段判断是否路由过滤
  console.log(to)
  if (to.matched.some(m => m.meta.auth)) {
    if (localStorage.getItem('user') !== null) {
      next()
    } else {
      //防止无限循环
      if (to.name === 'login' || to.name === 'bj') {
        next();
        return
      }
      next({
        path: '/login',
      });
    }
  } else {
    next()//若点击的是不需要验证的页面,则进行正常的路由跳转
  }
});
